<template>
  <NotificationText v-bind="$props">
    <template #primary>
      <i>{{notification.data.userLeftName}}</i> hat den Raum
      <i>{{notification.data.roomName}}</i> verlassen
    </template>
    <template #actions-prepend>
      <v-btn
        small
        text
        color="accent"
        :to="relativeURL(notification.data.roomUrl)"
        @click="markRead"
      >Raum öffnen</v-btn>
    </template>
  </NotificationText>
</template>

<script>
  import NotificationTextMixin from '../notification-text-mixin';


  export default {
    name: 'RoomLeft',

    mixins: [
      NotificationTextMixin
    ]
  };
</script>
